class DowntimeCalculator extends HTMLElement {
  connectedCallback() {
    this.hours = parseFloat(this.dataset.hours) || 25;
    this.currency = this.dataset.currency || '$';
    this.locale = this.dataset.locale || 'en-AU';

    this.staffInput = this.querySelector('[data-staff]');
    this.rateInput = this.querySelector('[data-rate]');

    this.staffDisplays = this.querySelectorAll('[data-staff-display]');
    this.rateDisplays = this.querySelectorAll('[data-rate-display]');
    this.hoursDisplays = this.querySelectorAll('[data-hours-display]');

    this.annualEl = this.querySelector('[data-annual]');
    this.monthlyEl = this.querySelector('[data-monthly]');
    this.threeYearEl = this.querySelector('[data-three-year]');

    this.formatter = new Intl.NumberFormat(this.locale, { maximumFractionDigits: 0 });

    [this.staffInput, this.rateInput].forEach((el) => {
      if (el) el.addEventListener('input', () => this.update());
    });

    this.update();
  }

  money(value) {
    return this.currency + this.formatter.format(Math.round(value));
  }

  setProgress(el) {
    if (!el) return;
    const min = parseFloat(el.min) || 0;
    const max = parseFloat(el.max) || 100;
    const val = parseFloat(el.value) || 0;
    const pct = max > min ? ((val - min) / (max - min)) * 100 : 0;
    el.style.setProperty('--range-progress', pct + '%');
  }

  update() {
    const staff = parseInt(this.staffInput && this.staffInput.value, 10) || 0;
    const rate = parseInt(this.rateInput && this.rateInput.value, 10) || 0;
    const annual = staff * rate * this.hours;

    this.staffDisplays.forEach((el) => {
      el.textContent = this.formatter.format(staff);
    });
    this.rateDisplays.forEach((el) => {
      el.textContent = this.formatter.format(rate);
    });
    this.hoursDisplays.forEach((el) => {
      el.textContent = this.formatter.format(this.hours);
    });

    if (this.annualEl) this.annualEl.textContent = this.money(annual);
    if (this.monthlyEl) this.monthlyEl.textContent = this.money(annual / 12);
    if (this.threeYearEl) this.threeYearEl.textContent = this.money(annual * 3);

    this.setProgress(this.staffInput);
    this.setProgress(this.rateInput);
  }
}

if (!customElements.get('downtime-calculator')) {
  customElements.define('downtime-calculator', DowntimeCalculator);
}
